module.exports = __webpack_public_path__ + "static/img/happy-customer.e19772a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/happy-customer.svg
// module id = ZQkU
// module chunks = 122